import { gql } from 'apollo-angular';

export const ACTIVITY_LIST_QUERY = gql`
  query ActivityList($input: MicrolessonHierarchyInput!) {
    microlessonByHierarchy(input: $input) {
      sections {
        ## subject
        name
        sections {
          ## domain
          name
          sections {
            ## skill gruop
            name
            content {
              ## standalone lessons at the skill group level
              title
              description
              learningTargets {
                learningTargetStatement
              }
              contentStatus
              episodeNumber
              grades
              uniqueId
              oid
              contentMedia {
                contentMediaType
                altText
                url
              }
            }
            sections {
              ## series
              name
              contentMedia {
                contentMediaType
                altText
                url
              }
              content {
                ## lessons at series level
                title
                description
                learningTargets {
                  learningTargetStatement
                }
                contentStatus
                episodeNumber
                grades
                uniqueId
                oid
                contentMedia {
                  contentMediaType
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const ACTIVITY_IDS_QUERY = gql`
  query ActivityIds($input: MicrolessonHierarchyInput!) {
    microlessonByHierarchy(input: $input) {
      sections {
        sections {
          sections {
            content {
              oid
              uniqueId
            }
            sections {
              content {
                oid
                uniqueId
              }
              sections {
                content {
                  oid
                  uniqueId
                  contentSeries {
                    content {
                      uniqueId
                      oid
                      contentSeries {
                        content {
                          uniqueId
                          oid
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const ACTIVITY_GRADES_QUERY = gql`
  query ActivityGrades($input: MicrolessonHierarchyInput!) {
    microlessonByHierarchy(input: $input) {
      sections {
        name
      }
    }
  }
`;

export const HAS_INCOMPLETE_ASSIGNMENTS_QUERY = gql`
  query HasIncompleteAssignments(
    $assignedInput: ContentAssignmentStudentInput!
    $inprogressInput: ContentAssignmentStudentInput!
  ) {
    assigned: contentAssignmentStudentData(input: $assignedInput) {
      assignments {
        dueDate
      }
    }
    inprogress: contentAssignmentStudentData(input: $inprogressInput) {
      assignments {
        dueDate
      }
    }
  }
`;

export const ASSIGNMENTS_DATA_QUERY = gql`
  query AssignmentsData($input: ContentAssignmentStudentInput!) {
    contentAssignmentStudentData(input: $input) {
      assignments {
        availableDate
        completedDate
        dueDate
        status
        content {
          product
          title
          uniqueId
          description
          manifest
          languageCode
          questionCount
          skill
          teiTypes
          contentMedia {
            altText
            contentMediaType
            url
          }
          learningTargets {
            learningTargetStatement
          }
        }
      }
    }
  }
`;

export const MICROLESSON_QUERY = gql`
  query Microlesson($input: MicrolessonInput!) {
    microlessonData(input: $input) {
      content {
        product
        skill
        domain
        title
        description
        languageCode
        contentMedia {
          url
          contentMediaType
        }
      }
    }
  }
`;

export const ASSIGNMENTS_QUERY = gql`
  query Assignments($input: ContentAssignmentStudentInput!) {
    contentAssignmentStudentData(input: $input) {
      assignments {
        isAssigned
        status
        id
        contentId
      }
    }
  }
`;
